import React from 'react';
import { noop } from 'lodash';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';

export class LastFocusKeeper {
  _store = {};

  save(key, element, options = {}) {
    const value = options.isIdSelector && !element.startsWith('#') ? `#${element}` : element;
    this._store[key] = value;
  }

  getSaved(key) {
    return this._store[key];
  }

  apply(key, cb = noop) {
    const lastFocusedElem = this.getSaved(key);
    if (lastFocusedElem) {
      SpatialNavigationWrapper.focus(lastFocusedElem);
      cb();
    }
  }

  reset(key) {
    delete this._store[key];
  }

  hasSaved(key) {
    return this.getSaved(key);
  }

  select(key) {
    return {
      save: this.save.bind(this, key),
      getSaved: this.getSaved.bind(this, key),
      apply: this.apply.bind(this, key),
      reset: this.reset.bind(this, key),
      hasSaved: this.hasSaved.bind(this, key),
    };
  }
}

const lastFocusKeeper = new LastFocusKeeper();

export default function withKeepingLastFocus(WrappedComponent) {
  return props => {
    return <WrappedComponent {...props} lastFocusKeeper={lastFocusKeeper} />;
  };
}
